// Emit “font-loaded” event so expandable components know to recalc their height
document.fonts.ready.then(() => {
  let d = document.documentElement;
  let fontEvent = new CustomEvent('fonts-loaded');
  d.dispatchEvent(fontEvent);
  d.classList.add('font-loaded');
});

// Nav toggle
import './modules/nav';

// NOTE: Trevor requested we disable hiding the header on scroll
// https://trevorproject.atlassian.net/browse/WEB-94
//
// Hide header on scroll in desktop
// import './modules/header-scroll-hide';

// Detect when the hero has scorlled out of the viewport
import './modules/hero-observer';

// Detect when bar charts have scrolled into view so we can trigger animations
import './modules/bar-chart-observer';

// Copy link URL to clipboard (used in chapter banners)
import './modules/copy-url';

// Bubble animations
import BubbleAnimations from './modules/bubble-animations';
new BubbleAnimations();

// Intro expand toggle (mobile only)
import IntroToggle from './modules/intro-toggle';
const introToggleEl = document.querySelector('.Intro-toggle');
if (introToggleEl) {
  new IntroToggle(introToggleEl);
}
